<template>
  <div v-if="showPicker" class="window-backdrop">
    <div class="window-wrapper">
      <div class="today-date-text">
        <div class="text-button" @click="cancle">取消</div>
        <img
          class="arrow-img"
          @click="toLastMonth"
          src="../assets/img/appImg/arrow_left.png"
        />
        <div class="today-date">{{ currentDateText }}</div>
        <img
          class="arrow-img"
          @click="toNextMonth"
          src="../assets/img/appImg/arrow_right.png"
        />
        <div class="text-button" @click="confirm">确定</div>
      </div>
      <div class="week-wrapper">
        <div class="week-item">周日</div>
        <div class="week-item">周一</div>
        <div class="week-item">周二</div>
        <div class="week-item">周三</div>
        <div class="week-item">周四</div>
        <div class="week-item">周五</div>
        <div class="week-item">周六</div>
      </div>
      <div class="month-day-wrapper">
        <div
          @click="handleDay(day)"
          v-for="day in days"
          :class="day.selected ? 'day-item-actived' : 'day-item'"
        >
          <div class="date-text">{{ day.isToday ? '今天' : day.dateText }}</div>
          <div class="chinese-date-text">{{ day.chineseDateText }}</div>
        </div>
        <div class="day-item" v-for="item in 7 - (days.length % 7)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { toLunar } from '@/utils';
export default {
  data() {
    return {
      days: [], // 当前月的所有日期的数据集合
      currentDateText: '', // 头部标题年月
      currentDate: '', // 初始化时为当前日期
      showPicker: false,
    };
  },
  methods: {
    open() {
      this.showPicker = true;
      this.initPicker();
    },
    confirm() {
      this.$emit('confirm', this.getSelectedDay());
    },
    cancle() {
      this.showPicker = false;
    },
    getSelectedDay() {
      for (var i = 0; i < this.days.length; i++) {
        if (this.days[i].selected) return this.days[i];
      }
    },
    /**
     * 日历点击事件,更新点击选中状态
     * @param {Object} day
     */
    handleDay(day) {
      if (!day.date) return;
      for (var i = 0; i < this.days.length; i++) {
        this.days[i].selected = day.dateText === this.days[i].dateText;
      }
      this.updateTitle(day);
    },
    /**
     * 更新标题年月
     * @param {Object} day
     */
    updateTitle(day) {
      this.currentDateText = this.getDateText(day.date);
    },
    /**
     * 下个月
     */
    toLastMonth() {
      this.currentDate = new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth() - 1,
        1
      );
      this.days = this.getPickerData(this.currentDate);
      this.currentDateText = this.getDateText(this.currentDate);
    },
    /**
     * 上个月
     */
    toNextMonth() {
      this.currentDate = new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth() + 1,
        1
      );
      this.days = this.getPickerData(this.currentDate);
      this.currentDateText = this.getDateText(this.currentDate);
    },
    /**
     * 设置日历标题
     * @param {Object} day
     */
    getDateText(day) {
      return day.getFullYear() + '年' + (day.getMonth() + 1) + '月';
    },
    /**
     * 转换成周几
     * @param {Object} day
     */
    getWeekText(day) {
      let weekVal = day.getDay();
      let weekText = '';
      switch (weekVal) {
        case 0:
          weekText = '日';
          break;
        case 1:
          weekText = '一';
          break;
        case 2:
          weekText = '二';
          break;
        case 3:
          weekText = '三';
          break;
        case 4:
          weekText = '四';
          break;
        case 5:
          weekText = '五';
          break;
        case 6:
          weekText = '六';
          break;
      }
      return '周' + weekText;
    },
    /**
     * 计算某个月的天数
     * @param {Object} month
     */
    getMonthDaysLength(day, month) {
      day.setMonth(month);
      day.setDate(0);
      return day.getDate();
    },
    /**
     * 根据日期对象计算当前月份1日为星期几,
     * 从而计算日期数组开始需要添加几个空数据
     * @param {Object} day
     */
    getEmptyDays(day) {
      return new Date(day.setDate(1)).getDay();
    },
    /**
     * 根据传入的day对象获取当前月的所有日期数据
     * @param {Object} day
     */
    getPickerData(day) {
      let arr = [];
      let emptyLength = this.getEmptyDays(day);
      for (var i = 0; i < emptyLength; i++) {
        arr.push({}); // 根据当前月份1号是星期几向往数组里添加空数据
      }
      let month = day.getMonth() + 1;
      let daysLength = this.getMonthDaysLength(day, month); // 计算当前月份一共有多少天
      for (var i = 0; i < daysLength; i++) {
        let obj = {
          date: new Date(day.setDate(i + 1)), // Date类型的日期数据
          dateText: i + 1, // 用于显示的日期
          chineseDateText: toLunar(day.getFullYear(), month, i + 1).day, // 农历日期
          isToday:
            new Date().toDateString() ===
            new Date(day.setDate(i + 1)).toDateString(), // 是否是今天
          selected:
            new Date().toDateString() ===
            new Date(day.setDate(i + 1)).toDateString(), // 设置今天为选中状态
        };
        arr.push(obj);
      }
      return arr;
    },
    initPicker() {
      this.currentDate = new Date();
      this.currentDateText = this.getDateText(this.currentDate); // 初始化标题年月
      this.days = this.getPickerData(this.currentDate); // 默认当前日期初始化日历
    },
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.window-backdrop {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.window-wrapper {
  width: 80%;
  min-width: 300px;
  max-width: 800px;
  height: 500px;
  padding: 10px 15px;
  background: #fff;
  border-radius: 10px;
  border: 1px #000 solid;
  position: relative;
  z-index: 999999;
}

.week-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  font-weight: bold;

  .week-item {
    font-size: 14px;
    flex: 14.2857%;
    text-align: center;
  }
}

.today-date-text {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-between;
  line-height: 100%;
  padding: 0 20px;

  .text-button {
    font-size: 16px;
    color: #000;
    cursor: pointer;
  }

  .arrow-img {
    height: 24px;
    width: 15px;
  }

  .today-date {
    font-size: 18px;
    font-weight: bold;
  }
}

.month-day-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .day-item,
  .day-item-actived {
    flex: 14.2857%;
    padding: 10px 0;
    margin-bottom: 5px;
    font-size: 13px;
    cursor: pointer;
    overflow: hidden;
    font-weight: bold;

    .date-text,
    .chinese-date-text {
      text-align: center;
    }
  }

  .day-item {
    color: #333;
  }

  .day-item-actived {
    color: #fff;
    background: #2875dd;
    border-radius: 5px;
  }
}
</style>
